import React from 'react';

interface BookingSkeletonProps {
  isMobile?: boolean;
}

export function BookingSkeleton({ isMobile = false }: BookingSkeletonProps) {
  if (isMobile) {
    return (
      <div className="bg-white/90 backdrop-blur-sm rounded-3xl p-4 shadow-sm border border-gray-200/30 animate-pulse">
        <div className="flex items-start justify-between">
          <div className="flex-1">
            {/* Booking number and status */}
            <div className="flex items-center justify-between mb-3">
              <div className="h-4 bg-gray-200 rounded-full w-24"></div>
              <div className="h-6 bg-gray-200 rounded-full w-20"></div>
            </div>
            
            {/* Customer name */}
            <div className="h-5 bg-gray-200 rounded-full w-32 mb-2"></div>
            
            {/* Service info */}
            <div className="h-4 bg-gray-200 rounded-full w-40 mb-3"></div>
            
            {/* Date and time */}
            <div className="flex items-center space-x-4 mb-3">
              <div className="h-4 bg-gray-200 rounded-full w-24"></div>
              <div className="h-4 bg-gray-200 rounded-full w-16"></div>
            </div>
            
            {/* Total amount */}
            <div className="h-5 bg-gray-200 rounded-full w-20"></div>
          </div>
        </div>
      </div>
    );
  }

  // Desktop skeleton
  return (
    <div className="bg-white/90 backdrop-blur-sm rounded-2xl border border-gray-200/30 animate-pulse">
      <div className="px-6 py-4">
        <div className="flex items-center">
          {/* Checkbox */}
          <div className="w-4 h-4 bg-gray-200 rounded mr-4"></div>
          
          {/* Booking Number */}
          <div className="w-24 h-4 bg-gray-200 rounded mr-6"></div>
          
          {/* Customer */}
          <div className="flex-1 min-w-0 mr-6">
            <div className="w-32 h-4 bg-gray-200 rounded mb-1"></div>
            <div className="w-48 h-3 bg-gray-100 rounded"></div>
          </div>
          
          {/* Service */}
          <div className="w-40 mr-6">
            <div className="w-32 h-4 bg-gray-200 rounded mb-1"></div>
            <div className="w-24 h-3 bg-gray-100 rounded"></div>
          </div>
          
          {/* Date & Time */}
          <div className="w-32 mr-6">
            <div className="w-24 h-4 bg-gray-200 rounded mb-1"></div>
            <div className="w-16 h-3 bg-gray-100 rounded"></div>
          </div>
          
          {/* Status */}
          <div className="w-20 mr-6">
            <div className="w-16 h-6 bg-gray-200 rounded-full"></div>
          </div>
          
          {/* Total */}
          <div className="w-20 mr-6">
            <div className="w-16 h-4 bg-gray-200 rounded"></div>
          </div>
          
          {/* Actions */}
          <div className="w-8 h-4 bg-gray-200 rounded"></div>
        </div>
      </div>
    </div>
  );
}

interface BookingSkeletonListProps {
  count?: number;
  isMobile?: boolean;
}

export function BookingSkeletonList({ count = 5, isMobile = false }: BookingSkeletonListProps) {
  return (
    <div className={isMobile ? "space-y-3" : "space-y-2"}>
      {Array.from({ length: count }).map((_, index) => (
        <BookingSkeleton key={index} isMobile={isMobile} />
      ))}
    </div>
  );
}
